import { ConfirmationModal } from '../../../../ui/components/pure/modal-content/confirmation-modal.component';
import { SettingsMapper } from '../../mappings/mappings';
import { useMutationDeleteHubSettings, useQueryGetHub } from '../../../lockers/hubs.queries';

export interface DeleteHubModalProps {
  hubId: string;
  hubName?: string;
  onSuccess: () => void;
  onCancel: () => void;
}

export function DeleteHubModal(props: DeleteHubModalProps) {
  const deleteMutation = useMutationDeleteHubSettings();
  const hubResult = useQueryGetHub(props.hubId);
  const hubName = hubResult.data?.name ?? props.hubName ?? 'Hub';

  const onConfirm = async () => {
    await deleteMutation.mutateAsync({ hubID: props.hubId });
    props.onSuccess();
  };

  const errorMessage = deleteMutation.error ? 'Something went wrong. Please try again.' : undefined;
  const icon = SettingsMapper.HubTypeToIcon(hubResult.data?.type);

  return (
    <ConfirmationModal
      title="Delete Hub?"
      onCancel={props.onCancel}
      onConfirm={onConfirm}
      content={[hubName]}
      icon={icon}
      warning="Deleted hubs can never be used again! Only use this if the customer has removed the hub permanently, or they were initially created as the incorrect type."
      isLoading={deleteMutation.isLoading}
      errorMessage={errorMessage}
      actionButton={{
        label: 'Delete',
        color: 'danger'
      }}
      cancelButton={{
        label: 'Cancel',
        color: 'secondary'
      }}
    />
  );
}
